const styles = theme => ({
  notificationbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 45px',

    '& span': {
      fontSize: '16px',
      fontWeight: '500',
    },
    '& svg': {
      marginRight: '8px',
      width: '18px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '30px',
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: '16px',
      },
      '& span': {
        fontSize: '13px',
        fontWeight: '500',
      },
      '& svg': {
        marginRight: '8px',
        width: '18px',
      },
    },
  },
  notificationDetailArea: {
    maxHeight: '82vh',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '64vh',
    },
  },
  dueDate: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  checkallLink: {
    color: ' #096BCE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid #EBEEF3',
    textDecoration: 'none',
    padding: '16px 45px',
    cursor: 'pointer',
    '&:hover': { textDecoration: 'none' },
  },
  checkallLinkMain: {
    position: 'absolute',
    bottom: '0px',
    width: '100%',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      bottom: '70px',
    },
  },
  pendingLabel: {
    fontSize: '14px',
    fontWeight: '500',
    background: 'transparent',
    height: 'auto',
    '& span': {
      overflow: 'visible',
    },
  },
  applicationContent: {
    background: theme.palette.primary.white,
    padding: '16px 45px',
    position: 'relative',
    borderTop: '1px solid #EBEEF3',
    [theme.breakpoints.down('sm')]: {
      padding: '13px 20px',
    },
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder} !important`,
    },
  },
  subTitlethree: {
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    fontWeight: '400',
  },
  alignRight: {
    textAlign: 'right',
    color: '#484456',
    fontWeight: '400',
    fontSize: '14px',
    '&:before': {
      width: '8px',
      height: '8px',
      content: '""',
      background: '#096BCE',
      borderRadius: '100rem',
      display: 'inline-flex',
      marginRight: '6px',
    },
  },

  actioner: {
    color: '#8C9099',
    fontSize: '12px',
    '& svg': {
      marginRight: '5px',
    },
  },
  fontWeight500: {
    fontWeight: '500',
  },
  textSize12: {
    fontSize: '12px',
  },
});

export default styles;
